import { GatsbyProps } from 'models/gatsby-props';
import { container, darkGradient } from './fade-out-container.module.scss';

export const FadeOutContainer = ({ location }: GatsbyProps) => {
    return <div className={`${container} ${location?.pathname === '/contact' ? darkGradient : ''} `}></div>;
};
